/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_AskInputs */

const en_admin_ai_chat_ask = /** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask`)
};

const de_admin_ai_chat_ask = /** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen`)
};

const es_admin_ai_chat_ask = /** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntar`)
};

const fr_admin_ai_chat_ask = /** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander`)
};

const nl_admin_ai_chat_ask = /** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vragen`)
};

/** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */
const it_admin_ai_chat_ask = en_admin_ai_chat_ask;

/** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_ask = en_admin_ai_chat_ask;

/** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */
const pl_admin_ai_chat_ask = en_admin_ai_chat_ask;

/** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */
const hu_admin_ai_chat_ask = en_admin_ai_chat_ask;

/** @type {(inputs: Admin_Ai_Chat_AskInputs) => LocalizedString} */
const ro_admin_ai_chat_ask = en_admin_ai_chat_ask;

/**
* | output |
* | --- |
* | "Ask" |
*
* @param {Admin_Ai_Chat_AskInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_ask = /** @type {((inputs?: Admin_Ai_Chat_AskInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_AskInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_ask(inputs)
	if (locale === "de") return de_admin_ai_chat_ask(inputs)
	if (locale === "es") return es_admin_ai_chat_ask(inputs)
	if (locale === "fr") return fr_admin_ai_chat_ask(inputs)
	if (locale === "nl") return nl_admin_ai_chat_ask(inputs)
	if (locale === "it") return it_admin_ai_chat_ask(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_ask(inputs)
	if (locale === "pl") return pl_admin_ai_chat_ask(inputs)
	if (locale === "hu") return hu_admin_ai_chat_ask(inputs)
	return ro_admin_ai_chat_ask(inputs)
});
export { admin_ai_chat_ask as "admin.ai_chat.ask" }